// 进度条

// 引入模块样式
require('./progressBar.scss');

var 
	progressBarTmpl = require('./progressBar.ejs'),
	
	_default = {
		elem: null, 							 // 组件容器
		target: null,							 // 进度条DOM元素

		// 开始动画
		animateStart: function(animating){
			$('.progress-outer').show();
		},

		// 结束进度条动画
		end: function () { 
			that = this,
			$('.progress-outer').slideUp(function(){
				that.target.remove();
				that.elem.progress = null;
			});	
		},
	},
	

	// 新建一个对象
	progressBarFactory = function (options){
		if(options.elem && options.elem.progress){
			var elem = $(options.elem);
			elem.show();
		}else{
			var target = $( progressBarTmpl(options) );
			options.elem.progress = $.extend({}, options, {target: target});
			$(options.elem).html(target).show();
		}
		
		// 异步执行，让进度条 DOM 先显示出来。
		setTimeout(function(){
			options.elem.progress.animateStart();
		}, 10);

		return options.elem.progress;
	};



// 新建组件的入口函数
module.exports = function(options){
	return progressBarFactory( $.extend({}, _default, options) );
}


// WEBPACK FOOTER //
// ./src/common/progressBar/progressBar.js